var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairingAccruedItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M12.1 33.8s-.4.8.6 1.8l2.8 2.8c1.6 1.6 2.3.6 3.6-.6 1.3-1.3 2.2-2 .6-3.6l-2.8-2.8c-.9-.9-1.8-.6-1.8-.6M12 27.8s.4-.8-.6-1.7l-2.8-2.8c-1.6-1.6-2.3-.6-3.6.6-1.3 1.3-2.2 2-.6 3.6l2.8 2.8c1 .8 1.8.5 1.8.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.3 28l5.6 5.6M10.5 13.7C12.9 9.3 17.6 6 22.9 6c7.7 0 14 6.3 14 14 0 7-5.2 12.9-12 13.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 8.8,
    cy: 18,
    r: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.2 21.3h-6.7v-8.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairingAccruedItems);
export default __webpack_public_path__ + "static/media/pairingAccruedItems.c57661f91ae637528d4357cc31793f13.svg";
export { ForwardRef as ReactComponent };